import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-parameters',
  templateUrl: './list-parameters.component.html',
  styleUrls: ['./list-parameters.component.css']
})
export class ListParametersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
